export const ROOT = "/"
export const VCARD_MATCH_URL = 'vcardmatch/:matchid';
export const ALIGNMENTS = 'alignments';
export const RESUME = 'resume';
export const COMMENTS = 'comments';
export const PLAYERS = 'players';



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/routes/routes.ts